import { ReviewInterface } from "@swivl-mono/types";
import { LocationReviewStats } from "./ReviewDataHelpers";
import { TableProfileCollectData } from "./DataHelpers";

export function exportAllLocationsToCSV(locationStats: LocationReviewStats[], locationNames: { [key: number]: string }): void {
  const headers = ["Location Name", "Review Date", "Reviewer Name", "Rating", "Review Text", "Has Reply?"];

  const rows: string[][] = [];
  
  locationStats.forEach((stats) => {
    const locationName = locationNames[stats.locationId] || `Location ${stats.locationId}`;
    
    stats.allReviews.forEach((review) => {
      rows.push([
        escapeCSVField(locationName),
        new Date(review.reviewDate).toLocaleDateString("en-US"),
        escapeCSVField(review.reviewerName || "Anonymous"),
        review.rating.toString(),
        escapeCSVField(review.text || ""),
        review.hasReply ? "Yes" : "No",
      ]);
    });
  });

  const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");

  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  const filename = `all-location-reviews-${timestamp}.csv`;

  downloadCSV(csvContent, filename);
}

export function exportLocationReviewsToCSV(locationName: string, reviews: ReviewInterface[]): void {
  const headers = ["Review Date", "Reviewer Name", "Rating", "Review Text", "Has Reply?"];

  const rows = reviews.map((review) => [
    new Date(review.reviewDate).toLocaleDateString("en-US"),
    escapeCSVField(review.reviewerName || "Anonymous"),
    review.rating.toString(),
    escapeCSVField(review.text || ""),
    review.hasReply ? "Yes" : "No",
  ]);

  const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");

  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  const safeLocationName = locationName.replace(/[^a-zA-Z0-9]/g, "-");
  const filename = `reviews-${safeLocationName}-${timestamp}.csv`;

  downloadCSV(csvContent, filename);
}

function escapeCSVField(field: string): string {
  if (field.includes(",") || field.includes('"') || field.includes("\n")) {
    return `"${field.replace(/"/g, '""')}"`;
  }
  return field;
}

function downloadCSV(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
}

export function exportProfileCollectToCSV(
  data: TableProfileCollectData[]
): void {
  const headers = [
    "Status",
    "Notes",
    "Name",
    "Email",
    "Phone",
    "Funnel",
    "Location",
    "Conversation Link",
    "Updated"
  ];

  const rows = data.map(row => [
    escapeCSVField(row.crmStatus),
    escapeCSVField(row.notes),
    escapeCSVField(row.name || "-"),
    escapeCSVField(row.email || "-"),
    escapeCSVField(row.phone || "-"),
    escapeCSVField(row.funnel),
    escapeCSVField(row.locationName),
    `${window.location.origin}${row.conversationLink}`,
    row.updatedAt.toLocaleDateString("en-US") + " " + row.updatedAt.toLocaleTimeString("en-US"),
  ]);

  const csvContent = [headers, ...rows].map(row => row.join(",")).join("\n");

  const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, "-");
  const filename = `profile-collect-${timestamp}.csv`;

  downloadCSV(csvContent, filename);
}
